/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M19.489 1h-14a2 2 0 00-2 2v18a2 2 0 002 2h14a2 2 0 002-2V3a2 2 0 00-2-2zM6.987 14h1.059m-1.059 3.889h1.059M11.932 14h1.06m3.94 0h1.06m-6.06 3.889h1.06m3.94 0h1.06"
      />
      <rect width="11.055" height="4.347" x="6.942" y="4.812" stroke="currentColor" strokeWidth="2" rx="1" />
    </svg>
  );
});

IconComponent.displayName = 'IconMortgageCalculator24';

export const IconMortgageCalculator24: React.FC<ISVGIconProps> = createIcon(IconComponent);
